module.exports = __webpack_public_path__ + "static/media/start.d7389b49.svg";